export default __webpack_public_path__ + "static/media/lesson_button.5cba878b.png";